module.exports = __webpack_public_path__ + "img/IT0001079603126.97423473.png";